import type {
  OfferingsSearchPayload,
  OfferingsSearchResponse,
} from '@de/types/offerings';
import { getApiConfig } from '../../services/api/utils';
import { uuid } from '../../shared/utils';
import { createServiceTrackedHeaders } from '../createServiceTrackedHeaders';
import { OfferingsServiceApiClient } from '@highereducation/offerings';

export const getOfferingsSearch = async (
  params: OfferingsSearchPayload,
): Promise<OfferingsSearchResponse> => {
  try {
    const config = getApiConfig();
    const offeringsBaseUrl = config.offeringsSearchApiUrl ?? '';

    if (!offeringsBaseUrl) {
      throw new Error('Offerings base URL is not set');
    }

    const defaultHeaders = createServiceTrackedHeaders(uuid());

    const client = new OfferingsServiceApiClient({
      baseUrl: offeringsBaseUrl,
      defaultHeaders,
    });

    const response = await client.getSearchOfferings(params);
    return response as OfferingsSearchResponse;
  } catch (error) {
    console.error('Get Search failed:', error);
    throw error;
  }
};
